"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ArrowRightLine["default"];
  }
});

var _ArrowRightLine = _interopRequireDefault(require("./lib/icons/ArrowRightLine"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
